import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal } from 'react-bootstrap';


function ReportRisks({ dados, filtrosEsfera = { Social: true, Governança: true, Ambiental: true } }) {

    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState();
    const [activeIndex, setActiveIndex] = useState();

    // Filtrar riscos baseado na Esfera
    const riscosFiltrados = dados && dados['Riscos ESG'] ? dados['Riscos ESG'].filter((item) => {
        const esfera = item.Esfera;
        return filtrosEsfera[esfera] === true;
    }) : [];

    const handleClickInfo = (index) => {
        setActiveIndex(index);
        setActiveData(riscosFiltrados[index]);
        setShowModal(true);
    }

    return (
        <>
            <span className="fs-6">Foram identificados <b className="fs-5">{riscosFiltrados.length} riscos</b></span>

            <Row className='d-flex scrollbar mt-3 pt-4' style={{ height: 'calc(100vh - 560px)' }}>
                {riscosFiltrados.length > 0 && riscosFiltrados.map((item, index) =>
                (
                    <Col md={4} key={index}>
                        <div className='rect-content-risks'>
                            <div className='rect-header'>
                                <div className={'rect-tag ' + item.Esfera.replace('ç', 'c').toLowerCase()}>{item.Esfera}</div>
                            </div>
                            <div className='rect-tx-value'>Peso: {item.Peso}</div>
                            <p className='rect-tx-1' title={index + 1 + '- ' + item.Título}>{index + 1 + '- ' + item.Título}</p>
                            <div className='rect-tx-2 truncate'>{item['Descrição Detalhada']}</div>
                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(index)}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    </Col>
                ))}
                {riscosFiltrados.length === 0 && (
                    <Col md={12}>
                        <p className="text-center mt-4">Nenhum risco encontrado com os filtros selecionados.</p>
                    </Col>
                )}
            </Row>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Risco</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData && (
                        <>
                            <div className="d-flex justify-content-between mb-3">
                                <div className={'rect-tag small inmodal ' + activeData.Esfera.replace('ç', 'c').toLowerCase()}>{activeData.Esfera}</div>
                                <div className='rect-tx-value fs-5'>Peso: {activeData.Peso}</div>
                            </div>
                            <p className='rect-tx-1' title={activeIndex + 1 + '- ' + activeData.Título}>{activeIndex + 1 + '- ' + activeData.Título}</p>
                            <div className='mb-3'>{activeData['Descrição Detalhada']}</div>
                            
                            {(activeData.ODS && activeData.ODS !== '') && 
                                <p title={'ODS: ' + activeData.ODS}><b>ODS: </b> {activeData.ODS}</p>
                            }
                            {(activeData.GRI && activeData.GRI !== '') &&
                                <p title={'GRI: ' + activeData.GRI}><b>GRI: </b> {activeData.GRI}</p>
                            }
                            {(activeData.ETHOS && activeData.ETHOS !== '') &&
                                <p title={'ETHOS: ' + activeData.ETHOS}><b>ETHOS: </b>{activeData.ETHOS}</p>
                            }
                            {(activeData['Resolução BACEN nº 4.557/2017'] && activeData['Resolução BACEN nº 4.557/2017'] !== '') &&
                                <p title={'Resolução BACEN nº 4.557/2017: ' + activeData['Resolução BACEN nº 4.557/2017']}><b>Resolução BACEN nº 4.557/2017: </b>{activeData['Resolução BACEN nº 4.557/2017']}</p>
                            }
                            {(activeData['SUSEP (Circular 666/2022)'] && activeData['SUSEP (Circular 666/2022)'] !== '') &&
                                <p title={'SUSEP (Circular 666/2022): ' + activeData['SUSEP (Circular 666/2022)']}><b>SUSEP (Circular 666/2022): </b>{activeData['SUSEP (Circular 666/2022)']}</p>
                            }
                            {(activeData['BACEN (Resolução 4557/2017)'] && activeData['BACEN (Resolução 4557/2017)'] !== '') &&
                                <p title={'BACEN (Resolução 4557/2017): ' + activeData['BACEN (Resolução 4557/2017)']}><b>BACEN (Resolução 4557/2017): </b>{activeData['BACEN (Resolução 4557/2017)']}</p>
                            }
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportRisks;